const ITEMS = [
  "Digital Mapping",
  "Elevation Analysis",
  "Hydraulic Calculations",
  "Pressure Class",
  "Pump Selection",
  "Air Valves & NRV",
  "Design Reports",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee-band"
      className="border-y border-slate-200 bg-white py-6"
      aria-hidden="true"
    >
      <div className="flex overflow-hidden">
        <div className="pm-marquee flex shrink-0 items-center whitespace-nowrap">
          {row.map((t, i) => (
            <span key={i} className="flex items-center">
              <span className="px-8 font-heading text-2xl font-bold tracking-tight text-slate-300 sm:text-3xl">
                {t}
              </span>
              <span className="h-2 w-2 rounded-full bg-[#5aa72f]" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
